module.exports = __webpack_public_path__ + "static/media/20ECE32.9eb0624f.jpg";